import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTabs } from './type';

type Props = {
    activeTab: HeaderTabs;
};

const FinderApplicationModuleFooter = ({ activeTab }: Props) => {
    const { t } = useTranslation('finderApplicationModuleDetails');

    if (activeTab !== HeaderTabs.MainDetails) {
        return null;
    }

    return (
        <Button form="updateForm" htmlType="submit" type="primary">
            {t('finderApplicationModuleDetails:mainActionButtons.update')}
        </Button>
    );
};

export default FinderApplicationModuleFooter;
